import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';

import Icon from 'components/Icon';
import Paragraph from 'components/Paragraph';

import {
  MainWrapper,
  RowWrapper,
} from 'apps/project/views/statusMessage.styles';
import { CircleWrapper, SpanLink } from 'apps/project/styles';

const StatusMessage = withNamespaces()(
  observer(props => {
    const { status } = props;

    const defaultErrorObj = {
      iconName: 'close',
      iconSize: 'medium',
      color: 'wfOrange',
      messageColor: 'wfOrange',
      message: (
        <Trans>
          There was an error while exporting your repositories, please check the
          URL and{' '}
          <SpanLink onClick={() => props.tryAgain()}>try again</SpanLink> or{' '}
          <SpanLink onClick={() => props.cancelImport()}>cancel</SpanLink>
        </Trans>
      ),
    };

    const status_dict = {
      pending: {
        iconName: 'hour_glass',
        iconSize: 'medium',
        message: (
          <Trans>We will process your request as soon as possible.</Trans>
        ),
      },
      importing: {
        iconName: 'hour_glass',
        iconSize: 'medium',
        message: (
          <Trans>
            Your files are being downloaded. This may take a moment. We’ll let
            you know once we’re done.
          </Trans>
        ),
      },
      importing_error_authorization_required: {
        iconName: 'warning',
        iconSize: 'medium',
        color: 'wfYellow',
        // messageColor: 'wfYellow',
        message: (
          <Trans>
            Looks like what you&apos;re trying to import is private. Please{' '}
            <SpanLink onClick={() => props.tryAgain()}>
              authenticate and grant access
            </SpanLink>{' '}
            or{' '}
            <SpanLink onClick={() => props.cancelImport()}>
              cancel the import.
            </SpanLink>
          </Trans>
        ),
      },
      importing_error_data_unreachable: {
        iconName: 'close',
        iconSize: 'medium',
        color: 'wfOrange',
        messageColor: 'wfOrange',
        message: (
          <Trans>
            We couldn&apos;t find anything at the URL you provided. Please{' '}
            <SpanLink onClick={() => props.cancelImport()}>
              cancel the import
            </SpanLink>{' '}
            and try again.
          </Trans>
        ),
      },
      importing_successfully: {
        iconName: 'hour_glass',
        iconSize: 'medium',
        message: (
          <Trans>Your files have been downloaded and are being processed</Trans>
        ),
      },
      exporting: {
        iconName: 'hour_glass',
        iconSize: 'medium',
        message: (
          <Trans>
            Your files are being uploaded to Wikifactory. This may take a
            moment. We’ll let you know once we’re done.
          </Trans>
        ),
      },
      exporting_successfully: {
        iconName: 'check',
        iconSize: 'default',
        message: (
          <Trans>Your files have been uploaded sucessfully. Wrapping up!</Trans>
        ),
      },
      exporting_error_authorization_required: defaultErrorObj,
      exporting_error_data_unreachable: defaultErrorObj,
    };

    const mainObj = status_dict[status];

    return (
      <MainWrapper>
        <RowWrapper messageColor={mainObj?.messageColor || 'wfBlack'}>
          {mainObj?.iconName && (
            <CircleWrapper color={mainObj?.color || 'wfBlack'}>
              <Icon
                name={mainObj.iconName}
                size={mainObj?.iconSize || 'default'}
              />
            </CircleWrapper>
          )}
          {mainObj?.message && <Paragraph>{mainObj.message}</Paragraph>}
        </RowWrapper>
      </MainWrapper>
    );
  }),
);

StatusMessage.propTypes = {
  status: PropTypes.string,
  tryAgain: PropTypes.func,
  cancelImport: PropTypes.func,
};

export default StatusMessage;
